import LinearProgress from '@mui/material/LinearProgress'
import {memo} from 'react'

export const DashboardProgress = memo(function DashboardProgress() {
  return <LinearProgress sx={SX}/>
})

// Hidden for the first 300ms so a fast load never blinks; an animation, not a transition-delay, which MUI
// zeroes under prefers-reduced-motion.
const SX = {
  position: 'absolute',
  width: '100%',
  '@keyframes delayed-appearance': {from: {visibility: 'hidden'}},
  animation: 'delayed-appearance 0s 300ms backwards',
} as const
